import React, { useRef, useEffect } from 'react';
import moment from 'moment';
import Cell from './cell';
import { getStateTime } from './helper';

const Row = ({ data, style, itemSize, listRef, resource, page, setLoadDetailsModalIsOpen, setCurrentRow }) => {
    const rowRef = useRef(null);

    const appointment = data?.rowState?.stopData?.appointment;
    let checkIn = '';
    let stateId = '';
    if (data.rowState.loadType === 'pickLoad') {
        checkIn = data?.rowState?.stopData?.pickIn;
        stateId = data?.rowState?.stopData?.pickStateId;
    } else if (data.rowState.loadType === 'dropLoad') {
        checkIn = data?.rowState?.stopData?.dropIn;
        stateId = data?.rowState?.stopData?.dropStateId;
    };

    let warehouseTime = data?.rowState.type === 'stop' && getStateTime(stateId);

    const date = new Date(checkIn);
    const formattedCheckIn = moment(date)
        .seconds(0)
        .milliseconds(0)
        .format("YYYY-MM-DDTHH:mm:ss");
    
    const checkInIsLaterThenAppointment = checkIn && appointment && appointment < formattedCheckIn;
    const noCheckInAndTimeIsLaterByZone = appointment && !checkIn && new Date(warehouseTime) > new Date(appointment);
    if (data.rowState.type === 'stop') {
        console.log('START')
        console.log('checkInIsLaterThenAppointment', checkInIsLaterThenAppointment)
        console.log('appointment', appointment)
        console.log('formattedCheckIn', formattedCheckIn)
        console.log('appointment < formattedCheckIn', appointment < formattedCheckIn)
        console.log('END')
        
        console.log('START 2')
        console.log('noCheckInAndTimeIsLaterByZone', noCheckInAndTimeIsLaterByZone)
        console.log('!checkIn', !checkIn)
        console.log('warehouseTime', new Date(warehouseTime))
        console.log('appointment', new Date(appointment))
        console.log('warehouseTime > appointment', new Date(warehouseTime) > new Date(appointment))
        console.log('END 2')
        console.log('___________________________________')

    }

    const isAppointmentInPast = (checkInIsLaterThenAppointment || noCheckInAndTimeIsLaterByZone) && page === 'pastLoads';
    
    let isDeliveredBtnActive = false;
    if (data.rowState.type === 'dropLoad') {
        const allPickAPPTAreExist = data.rowState.loadData.pickStop.filter(stop => stop.pickIn && stop.pickOut).length === data.rowState.loadData.pickStop.length;
        const allDropAPPTAreExist = data.rowState.loadData.dropStop.filter(stop => stop.dropIn && stop.dropOut).length === data.rowState.loadData.dropStop.length;
        isDeliveredBtnActive = allDropAPPTAreExist && allPickAPPTAreExist;
    };

    useEffect(() => {
        if (rowRef.current) {
            listRef.current.resetAfterIndex(0);
        }
    }, [rowRef, listRef]);

    style.width = 'max-content';
    let color = data.rowState.type === 'load' || data.rowState.type === 'dropLoad' ? '#65A7A5' : 
                data.rowState.type === 'stop' ? '#D9EBEB' :
                data.rowState.type === 'separator' ? 'Gray' :
                'inherit';
    
    // const border = data.rowState.type === 'separator' ? '1px solid Gray' : 'inherit';
    // const rowStyle = { ...style, ...{ height:  `${itemSize}px`, backgroundColor: color, fontSize: '10px', border: border } };
    const rowStyle = { ...style, ...{ height:  `${itemSize}px`, backgroundColor: color, fontSize: '9px' } };

    const cellContent = (i, ind) => {
        const key = `${ind}_${i.key}`;
        return (<Cell
            key={key}
            cellData={i}
            itemSize={data.rowState.type === 'load' || data.rowState.type === 'dropLoad' ? '30px' : itemSize}
            rowState={data.rowState}
            resource={resource}
            page={page}
            isAppointmentInPast={isAppointmentInPast}
            isDeliveredBtnActive={isDeliveredBtnActive}
            setLoadDetailsModalIsOpen={setLoadDetailsModalIsOpen}
            setCurrentRow={setCurrentRow}
        />);
    };

    return data ?
        <div className='resp-table-row' style={{ ...rowStyle, display:'flex' }}>
            {data.row.map(cellContent)}
        </div> : null;
    };

export default Row;